<div class="details-container">

  <div class="details-header" style="background: url(assets/images/hbs-sch2.jpg);">
      
    <div class="details-banner">
        <h1>The Henrietta Barnett School</h1>
        <h2>11 Plus (11+) Exam Information</h2>
    </div>
</div>


<div class="details-publisher">
  <span><strong>Published by - SEHYOG Academy</strong></span>
</div>

<div class="details-content">

  <div class="details-section">

    <h3>Introduction</h3>

    <div class="spacer"></div>

    <p>The Henrietta Barnett School (HBS) is a highly-regarded all-girls grammar school with academy status, nestled in the scenic Hampstead Garden Suburb, London. Philanthropist Dame Henrietta Barnett established the school in 1911. Her vision for the school was to provide a high-quality education to girls from various backgrounds, thereby promoting social equality and cohesion. The campus masterfully merges contemporary facilities with historic architecture, situated within the conservation area that offers a serene and stimulating learning atmosphere. <br>
      HBS features an all-encompassing, balanced, and forward-thinking curriculum designed to foster intellectual, creative, and physical development in its students. It provides a holistic education focusing on key subjects like mathematics, science, humanities, and languages that help build a strong foundation for students’ academic and personal development. <br> Students have the opportunity to engage in a wide variety of clubs catering to interests like debating, robotics, creative writing, and environmental conservation. The school also provides a comprehensive sports program, facilitating participation in athletics, netball, gymnastics, tennis, and other activities. These extra-curricular experiences enable students to nurture essential life and soft skills, including teamwork, leadership, effective communication, and problem-solving. <br>
      At the core of Henrietta Barnett School’s philosophy is a dedication to academic distinction and personal growth and the cultivation of a supportive community. It fosters intellectual inquisitiveness, determination, and autonomous thinking, empowering students to realise their maximum potential. <br>
      The Henrietta Barnett School has consistently garnered recognition for its outstanding academic accomplishments, frequently ranking among the UK’s top educational institutions. Its students consistently excel in their examinations, achieving impressive pass rates and top grades. Reputable university placements further demonstrate its success, with a considerable number of students securing admissions to esteemed institutions like the University of Oxford and Cambridge, as well as other notable Russell Group universities.

 
</p>

    <div class="spacer"></div>

    <p>The consortium is dedicated to improving the efficiency and fairness of the admissions process for its member schools. Through collaboration, the schools share resources, expertise and administrative responsibilities, resulting in a unified and well-organised selection procedure. This collective effort aims to provide students from diverse backgrounds with equal opportunities to access high-quality education across the participating grammar schools.</p>

    

    <div class="spacer"></div>

    <h2>The Henrietta Barnett School 11 Plus (11+) Exam Information 2025</h2>

    <div class="spacer"></div>


    <p><strong>Address: </strong> Central Square, Hampstead Garden Suburb, London NW11 7BN</p>
    <p><strong>County:</strong> Hertfordshire / London Borough of Barnet</p>
    <p><strong>Admissions info:</strong> admissions&#64;hbschool.org.uk, 020 8458 8999</p>
    <p><strong>School type:</strong> Girls’ grammar</p>
    <p><strong>Number of places in Year 7: </strong> 104</p>
    <p><strong>Open Day date: </strong> July</p>
    <p><strong>11+ Exam date: </strong> September (Round 1) and October (Round 2)</p>
    <p><strong>Pass mark: </strong> AAim for 90%+ in our practice tests for Part 1.</p>
    <p><strong>Exam type / Board:</strong> Part 1: GL Assessment | Part 2: set by the school</p>

    <div class="spacer"></div>
    <div class="spacer"></div>

    <h2>The Henrietta Barnett School 11 Plus (11+) Admissions</h2>

    <div class="spacer"></div>

    <p>Admission to The Henrietta Barnett School for Year 7 is by academic selection, based on 11 Plus exam results. HBS has over 2,000 applications and around 100 Year 7 places available. <br>

 

      The school strongly encourages prospective students and their parents to attend one of their Open Days, which take place in July. These typically include tours of facilities and meetings with staff, including the Head. <br>
      
       
      
      In the likely event that there are more applicants than available places, the school uses the following oversubscription criteria, giving priority to: </p>

      <div class="spacer"></div>

      <div><img src="assets/images/check-list.png" alt=""> <p>Children in looked after care, or those who have previously been in looked after care.</p></div>

      <div><img src="assets/images/check-list.png" alt=""> <p>Children eligible for Pupil Premium funding (up to 20 candidates only).</p></div>

      <div><img src="assets/images/check-list.png" alt=""> <p>All remaining candidates in rank score order from 11 Plus exam(s).</p></div>


    <div class="spacer"></div>

    <h2>How to Apply for 11 Plus (11+) Entry to The Henrietta Barnett School</h2>

    <div class="spacer"></div>

    <p>HBS follows the admissions process operated by the London Borough of Barnet. For your daughter to be considered for a Year 7 place, you must complete both the Common Application Form (CAF) via Barnet Local Authority and The Henrietta Barnett School Entrance Test Entry Form, which can be found on the school’s website when registration is open. </p>

    <p>It is important that parents apply to the school to be considered for a Year 7 place at HBS. If parents do not complete the school’s entry form on time, their daughter will not be able to take the entrance exam. Parents must also name the school on their Common Application Form (CAF) by the Local Authority’s deadline (end of October).</p>

    <div class="spacer"></div>

    <h2>The Henrietta Barnett School 11 Plus (11+) Exam Format</h2>

    <p>The Henrietta Barnett School entrance exams consist of two rounds, divided as follows:</p>

    <div><img src="assets/images/check-list.png" alt=""> <p> <strong>Round One:</strong> English, Verbal Reasoning and Non-Verbal Reasoning multiple-choice assessments set by GL Assessment.</p></div>

    <p>Following Round One, results from both sections will be combined and placed in rank order. The top 300 students will be invited back to sit the second exam (below).</p>

    <div><img src="assets/images/check-list.png" alt=""> <p> <strong>Round Two:</strong> English and Mathematics. The English section will test a student’s comprehension and creative writing skills, while the maths section focuses on problem solving skills.
    </p></div>


    <div class="spacer"></div>

    <p>Both papers are taken by candidates in the same session. After the tests are completed, they will be marked and the scores will be age-standardised.
    </p>

    <p>Achieving the Secondary Transfer Test Score (STTS) does not guarantee a place at the school. Each grammar school in Buckinghamshire sets its own additional admissions criteria.</p>

    <p>The scores from the two tests will be combined to produce a single, overall entrance test score for each candidate. Candidates who achieve a combined score of 210 or higher will have met the standard required and will be considered for admission to the school.</p>

    <p>The results of both tests will be used to determine the final rankings and place allocations for Year 7.</p>


    <div class="spacer"></div>

    <h2>The Henrietta Barnett School 11 Plus (11+) Exam Pass Marks and Target Scores</h2>

    <div class="spacer"></div>

    <p>Entrance to HBS is extremely competitive. Hence, strong exam performance is crucial to success at this school. Only the top 300 applicants in the Stage 1 exam will be considered for the Stage 2 test. </p>

    <p>There is no specific pass mark, but pupils who are able to score 90%+ consistently in our 11+ practice tests should be on track to pass the Stage 1 Henrietta Barnett 11+ assessment.</p>

    <p>Whilst there are no guarantees, this has historically been a fairly strong indicator that your child should do well in the HBS 11+ exam. Click here to learn about this school’s performance in comparison to other schools in the area.</p>

    <div class="spacer"></div>

    <p>Passing the test does not guarantee that your child will be offered a place. It simply means they have surpassed the required threshold. As such, it makes sense to aim for as high a score as possible.</p>

    <p>Don’t worry if your child is not scoring well in our practice papers from the outset. With targeted practice and focus, it’s possible to make big improvements in a short amount of time!</p>

    <div class="spacer"></div>

    <h2>How to Prepare for The Henrietta Barnett School 11 Plus (11+) Exam?</h2>

    <div class="spacer"></div>

    <p>To prepare your daughter successfully for the HBS 11+ entrance exam, we suggest that you make use of our targeted resources. Our practice tests enable familiarisation with the types of questions and the format of the actual exam, which will help her gain confidence in the lead up to the big day.
    </p>

    <p>With the use of our practice papers, you will be able to precisely identify your daughter’s strengths and weaknesses, which will guide you in devising a carefully thought-out revision plan that focuses on studying ‘little and often’. Moreover, our 11+ resources will help her get used to answering questions quickly and under time pressure. </p>



  </div>

</div>

</div>